import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' },
        { type: 'required', message: 'Please provide an event date' },
      ]
    },
    StartTime: {
      validations: [
        { type: 'required', message: 'Please provide a start time' },
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide a guest count' },
      ]
    },
    sitename: {
      validations: [
        { type: 'required', message: 'Please select a location' },
      ]
    },
    EventExtra1: {
      validations: []
    },
    EventExtra2: {
      validations: []
    },
    BusType: {
        validations: []
    },
    EventExtra3: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telNumber'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventDate'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Start Time:*',
            options: [
              { label: '8:00 AM', value: '8:00:00' },
              { label: '8:30 AM', value: '8:30:00' },
              { label: '9:00 AM', value: '9:00:00' },
              { label: '9:30 AM', value: '9:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
            ],
            mapping: 'StartTime'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Planned Guest Count:*',
            mapping: 'plannedguestcount'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Select Your Nearest Location:*',
            options: [
              {label: 'Lakewood' , value: 'Lakewood'},
              {label: 'Lone Tree' , value: 'Lone Tree'},
              {label: 'Westminster' , value: 'Westminster'}
            ],
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Meats:',
            options: [
              { label: 'Brisket', value: 'Brisket' },
              { label: 'Pork', value: 'Pork' },
              { label: 'Chicken', value: 'Chicken' },
              { label: 'Ribs', value: 'Ribs' },
              { label: 'Sausage', value: 'Sausage' },
              { label: 'Wings', value: 'Wings' },
            ],
            mapping: 'EventExtra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Sides:',
            options: [
              { label: 'Mac & Cheese', value: 'Mac & Cheese' },
              { label: 'Pit Smoked Beans', value: 'Pit Smoked Beans' },
              { label: 'Mashed Potatoes', value: 'Mashed Potatoes' },
              { label: 'Apple Coleslaw', value: 'Apple Coleslaw' },
              { label: 'Homemade Kettle Chips', value: 'Homemade Kettle Chips' },
              { label: 'Mixed Green Salad', value: 'Mixed Green Salad' },
            ],
            mapping: 'EventExtra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Pickup or Delivery?:',
            options: [
              { label: 'Pickup', value: 'Pickup' },
              { label: 'Delivery', value: 'Delivery' },
            ],
            mapping: 'BusType'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'If Delivery, please provide the address:',
            mapping: 'EventExtra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Other Comments or Questions?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'GQue BBQ Restaurant Contact Form',
    formId: '654',
    clientKey: '94FAAE5D-3B2F-4139-867C-783D7B09C1F7',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
